<template>
  <div>
    <div style="text-align: right">
      <div style=" margin-right: 20px">
        {{ $t("organstructure.lineName") }}：
        <el-input class="linename" :size="size" style="width: 180px; font-size: 12px" clearable
          :placeholder="$t('organstructure.inputlinename')" v-model="lineName">
        </el-input>
        <el-button style="margin-left: 30px" :size="size" @click="search(lineName)" plain type="primary">{{
          $t("public.query") }}</el-button>
        <el-button style="margin-left: 15px; cursor: pointer" :size="size" @click="add" type="primary">{{
          $t("public.add") }}</el-button>
        <el-button style="margin-left: 15px; cursor: pointer" :size="size" @click="onExportClick" type="primary">{{
          $t("public.export") }}</el-button>
      </div>
    </div>
    <div style="display: flex; flex-direction: row">
      <div>
        <i style="vertical-align: -9%" class="iconfont icon-icon_tab_list"></i>
        <span style="margin-top: 20px;margin-left:10px;font-size: 12px;font-weight: bold;">{{
          $t("organstructure.routelist") }}</span>
      </div>
      <el-dialog class="andoffice" :title="routetitle" :visible.sync="dialogFormVisible"
        :width="LanguageId == 1 ? '520px' : '600px'" :close-on-click-modal="false"
        style="font-size: 14px; text-align: center;">
        <el-divider></el-divider>

        <el-form :model="lineInfo" :label-position="labelPosition" :size="size"
          :label-width="LanguageId == 1 ? '90px' : '180px'" :rules="rules" ref="lineInfo"
          style="margin-top: 26px; margin-right: 20px">
          <el-row>
            <el-col :span="12"> 
              <el-form-item :label="$t('organstructure.lineName') + '：'" prop="linename">
                <el-input v-model="lineInfo.linename" :placeholder="$t('organstructure.inputlinename')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item :label="$t('organstructure.executeFleet') + '：'" prop="executeFleet">
                <el-select 
                  v-model="lineInfo.executeFleet" 
                  :placeholder="$t('organstructure.selectFleet')"
                >
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
       
            <el-col :span="12"> 
              <el-form-item :label="$t('organstructure.lineStartpoint') + '：'" style="margin-top: 15px">
                <el-input v-model="lineInfo.lineStartpoint"
                  :placeholder="$t('organstructure.inputlineStartpoint')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item :label="$t('organstructure.lineEndpoint') + '：'" style="margin-top: 15px">
                <el-input v-model="lineInfo.lineEndpoint"
                  :placeholder="$t('organstructure.inputlineEndpoint')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24"> 
              <el-form-item :label="$t('organstructure.linemileage') + '：'" style="margin-top: 15px"
                prop="linemileage">
                <el-input v-model="lineInfo.linemileage"
                  :placeholder="$t('organstructure.inputlinemileage')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item :label="$t('organstructure.contacts') + '：'" style="margin-top: 15px">
                <el-input v-model="lineInfo.linecontacts"
                  :placeholder="$t('organstructure.inputlinecontacts')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item :label="$t('operatormgr.mobileTel') + '：'" style="margin-top: 15px"
                prop="linetelephone">
                <el-input v-model="lineInfo.linetelephone" oninput="if(value.length>11)value=value.slice(0,11)"
                  onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                  :placeholder="$t('organstructure.inputtelphone')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24"> 
              <el-form-item :label="$t('organstructure.lineintroduction') + '：'" prop="desc"
                style="margin-top: 15px">
                <el-input type="textarea" v-model="lineInfo.lineintroduction"
                  :placeholder="$t('organstructure.inputlineintroduction')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: right; margin-top: 30px;">
          <el-button :size="size" @click="dialogFormVisible = false">{{
            $t("public.cancel")
          }}</el-button>
          <el-button :size="size" type="primary" @click="save('lineInfo')">{{
            $t("public.save")
          }}</el-button>
        </div>
      </el-dialog>
    </div>

    <div style="margin-top: 20px">
      <el-table border :size="size" ref="multipleTable" :data="tableData" tooltip-effect="dark" max-height="386"
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column :label="$t('public.index')" type="index" width="60" align="center">
        </el-table-column>
        <el-table-column prop="linename" :label="$t('organstructure.lineName')" width="250" align="center">
        </el-table-column>
        <el-table-column prop="linecontacts" :label="$t('organstructure.contacts')" show-overflow-tooltip width="100"
          align="center">
        </el-table-column>
        <el-table-column prop="linetelephone" :label="$t('operatormgr.mobileTel')" show-overflow-tooltip width="120"
          align="center">
        </el-table-column>
        <el-table-column prop="lineintroduction" :label="$t('organstructure.routeintroduction')" show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column :label="$t('public.Operation')" align="center" width="180">
          <template slot-scope="scope">
            <el-button :size="size" type="success" @click="modify(scope.$index, scope.row)">{{ $t("public.edit")
            }}</el-button>
            <el-button :size="size" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("public.del")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import language from "@/utils/getLanguageId";
import { EventBus } from "@/utils/event-bus.js";
import { setVehicles } from "@/utils/auth";
import { mapState } from "vuex";
import * as XLSX from 'xlsx'
export default {
  data() {
    return {
      LanguageId: 1,
      routetitle: "",
      lineName: "",
      labelPosition: "right",
      dialogFormVisible: false,
      tableData: [],
      options: [],
      lineInfo: {
        linename: "",
        linecontacts: "",
        linetelephone: "",
        lineintroduction: "",
        executeFleet: ""
      },
      deleteId: [],
      loading: false, // 添加加载状态
      rules: {
        linename: [
          {
            required: true,
            message: this.$t("organstructure.inputlinename"),
            trigger: "blur",
          },
        ],
        linemileage: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: this.$t("organstructure.entervalidNo"),
            trigger: "blur",
          },
        ],
        UnitPrice: [
          {
            required: true,
            message: this.$t("maintenancemanagement.entertheamount"),
            trigger: "blur",
          },
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: this.$t("maintenancemanagement.validamount"),
            trigger: "blur",
          },
        ],
        Quantity: [
          {
            required: true,
            message: this.$t("maintenancemanagement.inputquantity"),
            trigger: "blur",
          },
          {
            pattern: /^(0|[1-9][0-9]*)$/g,
            message: this.$t("maintenancemanagement.validnumber"),
            trigger: "blur",
          },
        ],
        executeFleet: [
          {
            required: true,
            message: this.$t("organstructure.inputexecutionfleet"),
            trigger: "change",
          },
        ],
        linetelephone: [
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("drivermanagement.inputphone"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      operator: (state) => state.user.operator,
      size: (state) => state.app.size,
    }),
  },
  mounted() {
    this.queryroutelist();
    this.LanguageId = language(this.$store.getters.locale);
    // 初始化时查询车队
    this.getFleetOptions();
  },
  methods: {
    onExportClick() {
      if (!this.tableData || this.tableData.length === 0) {
        this.$message.warning(this.$t('organstructure.no_data_export'));
        return;
      }
      const header = [
        this.$t('organstructure.lineName'),
        this.$t('organstructure.contacts'),
        this.$t('operatormgr.mobileTel'),
        this.$t('organstructure.routeintroduction')
      ];
      const rows = this.tableData.map(item => [
        item.linename || '',
        item.linecontacts || '',
        item.linetelephone || '',
        item.lineintroduction || ''
      ]);
      const aoa = [header, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.$t('organstructure.routelist'));
      const fileName = this.$t('organstructure.routelist') +
        this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
      XLSX.writeFile(wb, fileName);
      this.$message.success(this.$t('organstructure.export_success'));
    },
    // 查询车队选项
    getFleetOptions() {
      this.loading = true;
      return this.$api
        .queryFleetInfo({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            const newArr = res.data.map((item) => {
              return {
                value: item.fleetID,
                label: item.fleetname,
              };
            });
            this.options = newArr;
            console.log(newArr);
            return res;
          }
        })
        .catch(error => {
          console.error("查询车队失败:", error);
          this.$message.error(this.$t("organstructure.queryFleetFailed"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    queryroutelist() {
      this.$api
        .queryRouteList({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.tableData = res.data;
          }
        });
    },
    
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      console.log(selection);
      this.deleteId = selection.map((item) => item.lineID);
    },
    
    // 修改添加方法
    async add() {
      try {
        this.routetitle = this.$t("organstructure.addroute");
        this.loading = true;
        
        // 点击添加时查询车队接口
        await this.getFleetOptions();
        
        // 重置表单数据
        this.lineInfo = {
          linename: "",
          linecontacts: "",
          linetelephone: "",
          lineintroduction: "",
          executeFleet: this.options.length > 0 ? this.options[0].value : ""
        };
        
        this.dialogFormVisible = true;
        
        this.$nextTick(() => {
          if (this.$refs["lineInfo"]) {
            this.$refs["lineInfo"].clearValidate();
          }
        });
        
      } catch (error) {
        console.error("添加线路时出错:", error);
        this.$message.error(this.$t("organstructure.addRouteFailed"));
      } finally {
        this.loading = false;
      }
    },
    
    // 修改编辑方法，也查询车队
    async modify(index, row) {
      try {
        this.routetitle = this.$t("organstructure.modifyroute");
        this.loading = true;
        
        // 访问queryFleetInfo接口确保数据最新
        await this.getFleetOptions();
        
        // 复制行数据
        const rowCopy = JSON.parse(JSON.stringify(row));
        
        // 处理执行车队的值
        if (rowCopy.executeFleet) {
          const foundOption = this.options.find(option => 
            option.label === rowCopy.executeFleet || option.value === rowCopy.executeFleet
          );
          if (foundOption) {
            rowCopy.executeFleet = foundOption.value;
          }
        }
        
        this.lineInfo = rowCopy;
        this.dialogFormVisible = true;
        
        console.log("编辑线路:", this.lineInfo);
        
      } catch (error) {
        console.error("编辑线路时出错:", error);
        this.$message.error(this.$t("organstructure.modifyRouteFailed"));
      } finally {
        this.loading = false;
      }
    },
    
    handleDelete(index, row) {
      var newdeleteId = row.lineID.toString();
      var selectfleetinfo = {};
      this.$confirm(
        this.$t("organstructure.DeleteLine"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.changeroutestate(
            selectfleetinfo,
            newdeleteId,
            3,
            this.$t("public.hasDeleted")
          );
        })
        .catch(() => {
          // 取消删除
        });
    },

    search(val) {
      this.$api
        .queryRouteList({
          companyID: this.operator.CompanyId,
          BranchName: val,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.tableData = res.data;
          }
        });
    },
    
    save(formName) {
      var newValue = this.lineInfo;
      console.log(newValue);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.routetitle == this.$t("organstructure.addroute")) {
            this.changeroutestate(
              newValue,
              0,
              1,
              this.$t("public.add_success")
            );
          } else if (this.routetitle == this.$t("organstructure.modifyroute")) {
            var newaddId = this.lineInfo.lineID.toString();
            this.changeroutestate(
              newValue,
              newaddId,
              2,
              this.$t("public.edit_success")
            );
          }
        } else {
          return false;
        }
      });
    },
    
    open2(message) {
      this.$message({
        message: message,
        type: "success",
      });
    },
    
    open3(message1) {
      this.$message({
        message: message1,
        type: "warning",
      });
    },
    
    updatetree() {
      this.$api
        .queryVehicleTreeInfo({
          OperatorID: this.$store.getters.operator.OperatorId,
          CompanyID: this.$store.getters.operator.CompanyId,
        })
        .then((res) => {
          var tree = {};
          res.vehicles.forEach((element) => {
            element.isChecked = false;
            tree[element.id] = element;
          });
          console.log(res.vehicles);
          this.$store.dispatch("app/updateVehicleTree", {
            tree,
            rootId: res.vehicles[0].id,
          });
          this.$store.dispatch("app/updateVehicleData", res.vehicles);
          setVehicles(JSON.stringify(res.vehicles));
          EventBus.$emit("initVehicleTree");
        });
    },
    
    //添加、修改、删除线路
    changeroutestate(newfleetinfo, newfleetid, operatevalue, message) {
      this.$api
        .saveRouteInfo({
          companyID: this.operator.CompanyId,
          OptID: this.operator.OperatorId,
          lineID: newfleetid,
          linename: newfleetinfo.linename,
          executeFleet: newfleetinfo.executeFleet,
          linemileage: newfleetinfo.linemileage,
          lineStartpoint: newfleetinfo.lineStartpoint,
          lineEndpoint: newfleetinfo.lineEndpoint,
          linecontacts: newfleetinfo.linecontacts,
          linetelephone: newfleetinfo.linetelephone,
          lineintroduction: newfleetinfo.lineintroduction,
          operate: operatevalue,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.dialogFormVisible = false;
            this.queryroutelist();
            this.updatetree();
            this.$message({
              type: "success",
              message: message,
            });
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
  },
};
</script>